import { z } from 'zod'

export const BuildingStaffRoleEnum = z.enum(['PropertyManager', 'ShiftManager', 'Staff', 'Valet'])

export type BuildingStaffRole = z.infer<typeof BuildingStaffRoleEnum>

export const BuildingStaffUserSchema = z.object({
  // TODO: add more fields later to describe whole BE definition
  avatar: z.string().optional(),
  email: z.string().optional(),
  firstName: z.string(),
  id: z.number().or(z.string()),
  lastName: z.string(),
  role: BuildingStaffRoleEnum,
})

export type BuildingStaffUser = z.infer<typeof BuildingStaffUserSchema>

export const BuildingStaffModelSchema = z.object({
  // TODO: add more fields later to describe whole BE definition
  id: z.number().or(z.string()),
  jobTitle: z.string().optional(),
  phone: z.string().optional(),
  user: BuildingStaffUserSchema,
})

export type BuildingStaffModel = z.infer<typeof BuildingStaffModelSchema>

export const BuildingStaffTypeEnum = z.enum(['propertyManager', 'shiftManager', 'staff', 'valet'])

export type BuildingStaffType = z.infer<typeof BuildingStaffTypeEnum>
